module.exports = __webpack_public_path__ + "static/banner.484babf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newLayout/assets/distributor/banner.jpg
// module id = 808
// module chunks = 13643350389075